webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(7);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.silent = true;
	console.log = function () {};
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tracklist = __webpack_require__(8);
	
	var _Tracklist2 = _interopRequireDefault(_Tracklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Tracklist: _Tracklist2.default
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sheetrock = __webpack_require__(5);
	
	var _sheetrock2 = _interopRequireDefault(_sheetrock);
	
	var _vueInfiniteLoading = __webpack_require__(6);
	
	var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_sheetrock2.default.defaults.url = 'https://docs.google.com/spreadsheets/d/14ijhDhUVFCalOFVCzrBaGLuCkBS_JV_AKzu4k7IsfMc/edit#gid=0';
	
	exports.default = {
	  name: 'Tracklist',
	  components: {
	    InfiniteLoading: _vueInfiniteLoading2.default
	  },
	  data: function data() {
	    return {
	      orderBy: 'F',
	      filterTrackPlattform: ['ps4'],
	      availableFiltersPlattform: ['ps4', 'xb1', 'pc'],
	
	      filterTrackTypes: [],
	      availableFiltersType: ['Canyon', 'Valley', 'Lagoon', 'Stadium'],
	
	      filterTrackStyles: [],
	      availableFiltersStyle: ['Race', 'Tech', 'LOL', 'Fullspeed', 'Platform', 'Offroad', 'Trial', 'Concept', 'Full Throttle', 'Smash', 'Stunts', 'Random', 'Bonus'],
	
	      filterTrackLengths: [],
	      availableFiltersLengths: ['Mini', 'Short', 'Normal', 'Long', 'Multi-lap'],
	
	      loadingTracks: false,
	      resetTracksAfterLoad: true,
	      nextQuery: false,
	
	      tracks: [{ "trackid": "yusZ67iAoywrdLWZWrBbcwRmmr", "name": "#0", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "83174", "ratings": "20781", "rating": "3,5", "time1": "2:53.200", "time2": "3:04.000", "time3": "3:28.000", "author": "inyourgsicht", "authorid": "gebizigi-ps456ebcc0d64c73", "url": "/ps4/maps/yusZ67iAoywrdLWZWrBbcwRmmr", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/yusZ67iAoywrdLWZWrBbcwRmmr.jpg" }, { "trackid": "cjW23CRMdZlvsTg1ReKioOYGwXd", "name": "#3", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "81696", "ratings": "20362", "rating": "4", "time1": "2:21.427", "time2": "2:30.000", "time3": "2:50.000", "author": "inyourgsicht", "authorid": "gebizigi-ps456ebcc0d64c73", "url": "/ps4/maps/cjW23CRMdZlvsTg1ReKioOYGwXd", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/cjW23CRMdZlvsTg1ReKioOYGwXd.jpg" }, { "trackid": "mnjsyhEbvcphqndyWjvy4s4vIEm", "name": "#2", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "79090", "ratings": "20119", "rating": "4", "time1": "1:49.440", "time2": "1:57.000", "time3": "2:12.000", "author": "inyourgsicht", "authorid": "gebizigi-ps456ebcc0d64c73", "url": "/ps4/maps/mnjsyhEbvcphqndyWjvy4s4vIEm", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/mnjsyhEbvcphqndyWjvy4s4vIEm.jpg" }, { "trackid": "SM1yaBE2dh_riQka1Gd3hd3who2", "name": "#1", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "76322", "ratings": "19243", "rating": "3,5", "time1": "2:17.488", "time2": "2:26.000", "time3": "2:45.000", "author": "inyourgsicht", "authorid": "gebizigi-ps456ebcc0d64c73", "url": "/ps4/maps/SM1yaBE2dh_riQka1Gd3hd3who2", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/SM1yaBE2dh_riQka1Gd3hd3who2.jpg" }, { "trackid": "NLclGNRill_FWtITIYsvrNbzcW8", "name": "#7", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "51517", "ratings": "13665", "rating": "4", "time1": "4:17.530", "time2": "4:33.000", "time3": "5:10.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/NLclGNRill_FWtITIYsvrNbzcW8", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/NLclGNRill_FWtITIYsvrNbzcW8.jpg" }, { "trackid": "2r2y5RV2gGF2zMSARlKVr4FobQb", "name": "#5", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "50571", "ratings": "13435", "rating": "4", "time1": "3:06.660", "time2": "3:18.000", "time3": "3:44.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/2r2y5RV2gGF2zMSARlKVr4FobQb", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/2r2y5RV2gGF2zMSARlKVr4FobQb.jpg" }, { "trackid": "Nt7iJO4FT7Me358vJYo5fVDvjzf", "name": "#4", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "49862", "ratings": "13305", "rating": "4", "time1": "4:37.886", "time2": "4:55.000", "time3": "5:34.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/Nt7iJO4FT7Me358vJYo5fVDvjzf", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/Nt7iJO4FT7Me358vJYo5fVDvjzf.jpg" }, { "trackid": "HKAc4MqvXc0weEy9IXxQcH8sxo", "name": "#8", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "46204", "ratings": "12346", "rating": "4", "time1": "2:59.361", "time2": "3:11.000", "time3": "3:36.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/HKAc4MqvXc0weEy9IXxQcH8sxo", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/HKAc4MqvXc0weEy9IXxQcH8sxo.jpg" }, { "trackid": "3AcTOQqhc6M1UYjQPjPWU5tSwz0", "name": "#6", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "46098", "ratings": "12344", "rating": "4", "time1": "3:46.344", "time2": "4:00.000", "time3": "4:32.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/3AcTOQqhc6M1UYjQPjPWU5tSwz0", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/3AcTOQqhc6M1UYjQPjPWU5tSwz0.jpg" }, { "trackid": "DuaArdPd1qlxQPUAdykc6i_ukif", "name": "#11", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "45003", "ratings": "11677", "rating": "4", "time1": "2:32.974", "time2": "2:43.000", "time3": "3:04.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/DuaArdPd1qlxQPUAdykc6i_ukif", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/DuaArdPd1qlxQPUAdykc6i_ukif.jpg" }, { "trackid": "V0ojOkWwgrLnObUa4iR8by3X1l1", "name": "#10", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "44428", "ratings": "11880", "rating": "4", "time1": "4:23.077", "time2": "4:39.000", "time3": "5:16.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/V0ojOkWwgrLnObUa4iR8by3X1l1", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/V0ojOkWwgrLnObUa4iR8by3X1l1.jpg" }, { "trackid": "K7Z_izoPdADOKBCv49RvnROqw0m", "name": "#12", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "40774", "ratings": "11037", "rating": "4", "time1": "3:10.138", "time2": "3:22.000", "time3": "3:49.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/K7Z_izoPdADOKBCv49RvnROqw0m", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/K7Z_izoPdADOKBCv49RvnROqw0m.jpg" }, { "trackid": "2s7Ed53Vj43KbCk8zVbt4d0Gr9i", "name": "#3", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "39743", "ratings": "10558", "rating": "3,5", "time1": "4:35.623", "time2": "4:53.000", "time3": "5:31.000", "author": "inyourgsicht", "authorid": "gebizigi-ps456ebcc0d64c73", "url": "/ps4/maps/2s7Ed53Vj43KbCk8zVbt4d0Gr9i", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/2s7Ed53Vj43KbCk8zVbt4d0Gr9i.jpg" }, { "trackid": "vBg54AhLsprCM3fAYCngAeSfy9e", "name": "#13", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "35891", "ratings": "9108", "rating": "4", "time1": "3:01.832", "time2": "3:13.000", "time3": "3:39.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/vBg54AhLsprCM3fAYCngAeSfy9e", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/vBg54AhLsprCM3fAYCngAeSfy9e.jpg" }, { "trackid": "ZmRRriLWwW2VHvqZ3lCLFrgET5b", "name": "#14", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "33035", "ratings": "9077", "rating": "4", "time1": "4:33.943", "time2": "4:51.000", "time3": "5:29.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/ZmRRriLWwW2VHvqZ3lCLFrgET5b", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/ZmRRriLWwW2VHvqZ3lCLFrgET5b.jpg" }, { "trackid": "AdJf5K5lLOQiWJjF8spPW9UpCwb", "name": "#15", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "30074", "ratings": "8232", "rating": "4", "time1": "3:09.693", "time2": "3:22.000", "time3": "3:48.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/AdJf5K5lLOQiWJjF8spPW9UpCwb", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/AdJf5K5lLOQiWJjF8spPW9UpCwb.jpg" }, { "trackid": "KLLmiC4jH0ST5VrCB6TNcqIAC1i", "name": "#94", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "27947", "ratings": "6889", "rating": "4", "time1": "2:45.287", "time2": "2:56.000", "time3": "3:19.000", "author": "SnowHermit", "authorid": "kahyqixo-ps45759321b34610", "url": "/ps4/maps/KLLmiC4jH0ST5VrCB6TNcqIAC1i", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/KLLmiC4jH0ST5VrCB6TNcqIAC1i.jpg" }, { "trackid": "LyB3dgBh0KrYBXupJGuUSNXfuLk", "name": "#16", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "27823", "ratings": "8002", "rating": "4", "time1": "4:00.311", "time2": "4:15.000", "time3": "4:49.000", "author": "creddy777", "authorid": "mamygemu-ps456ec59405b845", "url": "/ps4/maps/LyB3dgBh0KrYBXupJGuUSNXfuLk", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/LyB3dgBh0KrYBXupJGuUSNXfuLk.jpg" }, { "trackid": "wZDRteQDp8kBtdcqWPKmUXGaPu9", "name": "#6", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "27403", "ratings": "8001", "rating": "4", "time1": "4:36.494", "time2": "4:54.000", "time3": "5:32.000", "author": "SpaceCorruption", "authorid": "wuxaluvi-ps4572556741929a", "url": "/ps4/maps/wZDRteQDp8kBtdcqWPKmUXGaPu9", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/wZDRteQDp8kBtdcqWPKmUXGaPu9.jpg" }, { "trackid": "m9KKcBszMPgciLhRmugG49Ek9Wc", "name": "#100", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "27053", "ratings": "6660", "rating": "4", "time1": "2:15.900", "time2": "2:25.000", "time3": "2:44.000", "author": "SnowHermit", "authorid": "kahyqixo-ps45759321b34610", "url": "/ps4/maps/m9KKcBszMPgciLhRmugG49Ek9Wc", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/m9KKcBszMPgciLhRmugG49Ek9Wc.jpg" }, { "trackid": "TxhTSXkWaQUXTUZxV9BQVoMNHKf", "name": "#99", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "26913", "ratings": "7082", "rating": "4", "time1": "2:17.466", "time2": "2:26.000", "time3": "2:45.000", "author": "SnowHermit", "authorid": "kahyqixo-ps45759321b34610", "url": "/ps4/maps/TxhTSXkWaQUXTUZxV9BQVoMNHKf", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/TxhTSXkWaQUXTUZxV9BQVoMNHKf.jpg" }, { "trackid": "JpaPm91tLJEgoeKtBxuv6DmP2Eh", "name": "#16", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "26399", "ratings": "7902", "rating": "4", "time1": "1:30.542", "time2": "1:36.000", "time3": "1:49.000", "author": "SpaceCorruption", "authorid": "wuxaluvi-ps4572556741929a", "url": "/ps4/maps/JpaPm91tLJEgoeKtBxuv6DmP2Eh", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/JpaPm91tLJEgoeKtBxuv6DmP2Eh.jpg" }, { "trackid": "lnJnPLfqqsIVd_MDrdBL0QeynEf", "name": "#14", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "26384", "ratings": "7372", "rating": "3,5", "time1": "1:45.462", "time2": "1:52.000", "time3": "2:07.000", "author": "SpaceCorruption", "authorid": "wuxaluvi-ps4572556741929a", "url": "/ps4/maps/lnJnPLfqqsIVd_MDrdBL0QeynEf", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/lnJnPLfqqsIVd_MDrdBL0QeynEf.jpg" }, { "trackid": "hHJRVacXhDdxFjmDAROuEPJDml0", "name": "#97", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "25994", "ratings": "6668", "rating": "4", "time1": "3:22.828", "time2": "3:35.000", "time3": "4:04.000", "author": "SnowHermit", "authorid": "kahyqixo-ps45759321b34610", "url": "/ps4/maps/hHJRVacXhDdxFjmDAROuEPJDml0", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/hHJRVacXhDdxFjmDAROuEPJDml0.jpg" }, { "trackid": "R9iRBUE7k12GD65OgcYBkihBh5h", "name": "#11", "type": "Canyon", "style": "Stunts", "length": "Long", "plays": "25950", "ratings": "7779", "rating": "4", "time1": "2:42.675", "time2": "2:53.000", "time3": "3:16.000", "author": "SpaceCorruption", "authorid": "wuxaluvi-ps4572556741929a", "url": "/ps4/maps/R9iRBUE7k12GD65OgcYBkihBh5h", "img": "https://s3-eu-west-1.amazonaws.com/tmturbo-prod-ps4-maps/R9iRBUE7k12GD65OgcYBkihBh5h.jpg" }]
	    };
	  },
	
	  computed: {
	    whereQuery: function whereQuery() {
	      var whereString = '';
	
	      if (this.filterTrackTypes.length && this.filterTrackTypes.length !== this.availableFiltersType.length) {
	        if (whereString.length === 0) {
	          whereString = 'WHERE ';
	        } else {
	          whereString += ' AND ';
	        }
	
	        var queryString = '(C=\'';
	        queryString += this.filterTrackTypes.join('\' or C=\'');
	        queryString += '\')';
	        whereString += queryString;
	      }
	
	      if (this.filterTrackStyles.length && this.filterTrackStyles.length !== this.availableFiltersStyle.length) {
	        if (whereString.length === 0) {
	          whereString = 'WHERE ';
	        } else {
	          whereString += ' AND ';
	        }
	
	        var _queryString = '(D=\'';
	        _queryString += this.filterTrackStyles.join('\' or D=\'');
	        _queryString += '\')';
	        whereString += _queryString;
	      }
	
	      if (this.filterTrackLengths.length && this.filterTrackLengths.length !== this.availableFiltersLengths.length) {
	        if (whereString.length === 0) {
	          whereString = 'WHERE ';
	        } else {
	          whereString += ' AND ';
	        }
	
	        var _queryString2 = '(E=\'';
	        _queryString2 += this.filterTrackLengths.join('\' or E=\'');
	        _queryString2 += '\')';
	        whereString += _queryString2;
	      }
	
	      if (this.filterTrackPlattform.length && this.filterTrackPlattform.length !== this.availableFiltersPlattform.length) {
	        if (whereString.length === 0) {
	          whereString = 'WHERE ';
	        } else {
	          whereString += ' AND ';
	        }
	
	        var _queryString3 = '(L=\'';
	        _queryString3 += this.filterTrackPlattform.join('\' or L=\'');
	        _queryString3 += '\')';
	        whereString += _queryString3;
	      }
	
	      console.log(whereString);
	
	      if (whereString !== null) {
	        return whereString;
	      } else {
	        return '';
	      }
	    }
	  },
	  created: function created() {
	    console.log('created tracklist');
	
	    _sheetrock2.default.defaults.url = 'https://docs.google.com/spreadsheets/d/1pBUCQIGKxkbPcxHD4RXvHGUx5MXn-3tTpO9Rb-V7mN0/edit#gid=0';
	    this.querySheet();
	  },
	  watch: {
	    'orderBy': function orderBy() {
	      this.filterHasChanged();
	    },
	    'filterTrackPlattform': function filterTrackPlattform() {
	      this.filterHasChanged();
	    },
	    'filterTrackTypes': function filterTrackTypes() {
	      this.filterHasChanged();
	    },
	    'filterTrackStyles': function filterTrackStyles() {
	      this.filterHasChanged();
	    },
	    'filterTrackLengths': function filterTrackLengths() {
	      this.filterHasChanged();
	    }
	  },
	  methods: {
	    querySheet: function querySheet(query, params) {
	      if (this.loadingTracks) {
	        this.nextQuery = {
	          query: query,
	          params: params,
	          reset: this.resetTracksAfterLoad
	        };
	        console.log('deferring', query, params);
	        return true;
	      } else {
	        console.log('deleting nextQuery');
	        this.nextQuery = false;
	      }
	
	      this.loadingTracks = true;
	
	      var defaultParams = {
	        query: query === undefined ? 'select A,B,C,D,E,F,G,H,I,J,K,L ' + this.whereQuery + ' order by ' + this.orderBy + ' desc' : query,
	        fetchSize: 20,
	        callback: this.sheetRockDataCallback
	      };
	
	      var finalParams = defaultParams;
	
	      for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	          if (params[key] !== undefined) {
	            finalParams[key] = params[key];
	          }
	        }
	      }
	
	      console.log('Sheetrock Query: ', finalParams);
	
	      (0, _sheetrock2.default)(finalParams);
	    },
	    sheetRockDataCallback: function sheetRockDataCallback(error, options, response) {
	      console.log('sheetRockDataCallback');
	
	      if (!error) {
	        console.log(response.rows);
	
	
	        if (this.resetTracksAfterLoad) {
	          this.tracks = [];
	          this.resetTracksAfterLoad = false;
	        }
	
	        var arrayLength = response.rows.length;
	        for (var i = 0; i < arrayLength; i++) {
	          var track = response.rows[i].cells;
	          if (track.trackid === 'trackid') {
	            continue;
	          }
	          track.url = '/' + track.plattform + '/maps/' + track.trackid;
	          track.img = 'https://s3-eu-west-1.amazonaws.com/tmturbo-prod-' + track.plattform + '-maps/' + track.trackid + '.jpg';
	          this.tracks.push(track);
	        }
	      } else {
	        console.log(error);
	      }
	
	      this.loadingTracks = false;
	      this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
	
	      if (this.nextQuery !== false) {
	        this.resetTracksAfterLoad = this.nextQuery.reset;
	        this.querySheet(this.nextQuery.query, this.nextQuery.params);
	        console.log('nextQuery !== false');
	      }
	    },
	    filterHasChanged: function filterHasChanged() {
	      console.log('Changed Filter');
	      this.resetTracksAfterLoad = true;
	      this.querySheet(undefined, { reset: true });
	    },
	    onInfinite: function onInfinite() {
	      console.log('Infinite-scroll triggerd');
	      if (this.loadingTracks === false) {
	        this.querySheet();
	      } else {
	        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
	      }
	    }
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(3)
	
	/* script */
	__vue_exports__ = __webpack_require__(1)
	
	/* template */
	var __vue_template__ = __webpack_require__(9)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(4)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(10)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-500db6fe"
	
	module.exports = __vue_exports__


/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('div', {
	    staticClass: "container"
	  }, [_h('tracklist')])])
	}},staticRenderFns: []}

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "tracklist"
	  }, [_h('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "filter"
	    }
	  }, [_h('div', {
	    staticClass: "col-md-12"
	  }, [_h('form', [_h('div', {
	    staticClass: "form-group orderby"
	  }, [_m(0), " ", _h('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (orderBy),
	      expression: "orderBy"
	    }],
	    staticClass: "custom-select",
	    attrs: {
	      "id": "orderBy"
	    },
	    on: {
	      "change": function($event) {
	        orderBy = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          return "_value" in o ? o._value : o.value
	        })[0]
	      }
	    }
	  }, [_m(1), " ", _m(2), " ", _m(3), " ", _m(4)])]), " ", _h('div', {
	    staticClass: "form-group filter filter--type"
	  }, ["\n            Platform:\n            ", _l((availableFiltersPlattform), function(filter) {
	    return [_h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (filterTrackPlattform),
	        expression: "filterTrackPlattform"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "id": filter
	      },
	      domProps: {
	        "value": filter,
	        "checked": Array.isArray(filterTrackPlattform) ? _i(filterTrackPlattform, filter) > -1 : _q(filterTrackPlattform, true)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = filterTrackPlattform,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = filter,
	              $$i = _i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (filterTrackPlattform = $$a.concat($$v))
	            } else {
	              $$i > -1 && (filterTrackPlattform = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            filterTrackPlattform = $$c
	          }
	        }
	      }
	    }), " ", _h('label', {
	      attrs: {
	        "for": filter
	      }
	    }, [_s(filter)])]
	  })]), " ", _h('div', {
	    staticClass: "form-group filter filter--type"
	  }, ["\n            Type:\n            ", _l((availableFiltersType), function(filter) {
	    return [_h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (filterTrackTypes),
	        expression: "filterTrackTypes"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "id": filter
	      },
	      domProps: {
	        "value": filter,
	        "checked": Array.isArray(filterTrackTypes) ? _i(filterTrackTypes, filter) > -1 : _q(filterTrackTypes, true)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = filterTrackTypes,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = filter,
	              $$i = _i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (filterTrackTypes = $$a.concat($$v))
	            } else {
	              $$i > -1 && (filterTrackTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            filterTrackTypes = $$c
	          }
	        }
	      }
	    }), " ", _h('label', {
	      attrs: {
	        "for": filter
	      }
	    }, [_s(filter)])]
	  })]), " ", _h('div', {
	    staticClass: "form-group filter filter--style"
	  }, ["\n            Style:\n            ", _l((availableFiltersStyle), function(filter) {
	    return [_h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (filterTrackStyles),
	        expression: "filterTrackStyles"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "id": filter
	      },
	      domProps: {
	        "value": filter,
	        "checked": Array.isArray(filterTrackStyles) ? _i(filterTrackStyles, filter) > -1 : _q(filterTrackStyles, true)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = filterTrackStyles,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = filter,
	              $$i = _i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (filterTrackStyles = $$a.concat($$v))
	            } else {
	              $$i > -1 && (filterTrackStyles = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            filterTrackStyles = $$c
	          }
	        }
	      }
	    }), " ", _h('label', {
	      attrs: {
	        "for": filter
	      }
	    }, [_s(filter)])]
	  })]), " ", _h('div', {
	    staticClass: "form-group filter filter--length"
	  }, ["\n            Length:\n            ", _l((availableFiltersLengths), function(filter) {
	    return [_h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (filterTrackLengths),
	        expression: "filterTrackLengths"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "id": filter
	      },
	      domProps: {
	        "value": filter,
	        "checked": Array.isArray(filterTrackLengths) ? _i(filterTrackLengths, filter) > -1 : _q(filterTrackLengths, true)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = filterTrackLengths,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = filter,
	              $$i = _i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (filterTrackLengths = $$a.concat($$v))
	            } else {
	              $$i > -1 && (filterTrackLengths = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            filterTrackLengths = $$c
	          }
	        }
	      }
	    }), " ", _h('label', {
	      attrs: {
	        "for": filter
	      }
	    }, [_s(filter)])]
	  })])])])]), " ", _h('div', {
	    staticClass: "row"
	  }, [_h('div', {
	    staticClass: "col-md-12"
	  }, [(loadingTracks) ? _h('div', {
	    staticClass: "alert alert-info"
	  }, [_m(5), "  This may take a while\n       "]) : _e()])]), " ", _h('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "tracklist"
	    }
	  }, [_l((tracks), function(track) {
	    return _h('div', {
	      staticClass: "col-md-3 col-xs-6"
	    }, [_h('div', {
	      staticClass: "card thumbnail"
	    }, [_h('div', {
	      staticClass: "hover-btn"
	    }, [_h('a', {
	      staticClass: "btn btn-primary btn-sm",
	      attrs: {
	        "href": 'https://players.turbo.trackmania.com' + track.url,
	        "target": "_blank"
	      }
	    }, ["Open"]), " ", _h('a', {
	      staticClass: " btn btn-primary   btn-sm",
	      attrs: {
	        "href": 'https://players.turbo.trackmania.com/' + track.plattform + '/maps/favorites/' + track.url.split('/').pop() + '/add',
	        "target": "_blank"
	      }
	    }, ["Add to Favorites"])]), " ", _h('img', {
	      staticClass: "card-img-top img-fluid",
	      attrs: {
	        "src": track.img,
	        "alt": track.name
	      }
	    }), " ", _h('div', {
	      staticClass: "card-block text-xs-center"
	    }, [_h('h4', {
	      staticClass: "card-title"
	    }, [_s(track.name) + " – ", _h('span', {
	      staticClass: "tag tag-success"
	    }, [_s(track.plattform)])]), " ", _h('h6', {
	      staticClass: "card-subtitle text-muted"
	    }, ["by " + _s(track.author)]), " ", _h('p', [_h('span', {
	      staticClass: "tag tag-info"
	    }, [_s(track.type)]), " ", _h('span', {
	      staticClass: "tag tag-info"
	    }, [_s(track.style)]), " ", _h('span', {
	      staticClass: "tag tag-info"
	    }, [_s(track.length)])]), " ", _h('table', {
	      staticClass: "table table-sm"
	    }, [_h('tbody', [_h('tr', [_m(6, true), " ", _h('td', [_s(track.plays)])]), " ", _h('tr', [_m(7, true), " ", _h('td', [_s(track.playsdiff)])]), " ", _h('tr', [_m(8, true), " ", _h('td', [_s(track.ratings)])]), " ", _h('tr', [_m(9, true), " ", _h('td', [_s(track.rating) + " / 5"])])])])])])])
	  }), " ", _h('infinite-loading', {
	    ref: "infiniteLoading",
	    attrs: {
	      "on-infinite": onInfinite
	    }
	  })])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('label', {
	    attrs: {
	      "for": "orderBy"
	    }
	  }, ["Order by: "])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "F"
	    }
	  }, ["Most Played (ever)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "I"
	    }
	  }, ["Most Played (recently)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "G"
	    }
	  }, ["Most Ratings"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "H"
	    }
	  }, ["Best Rating"])
	}},function (){with(this) {
	  return _h('strong', ["Loading Track Data"])
	}},function (){with(this) {
	  return _h('th', {
	    attrs: {
	      "scope": "row"
	    }
	  }, ["Plays"])
	}},function (){with(this) {
	  return _h('th', {
	    attrs: {
	      "scope": "row"
	    }
	  }, ["Recent"])
	}},function (){with(this) {
	  return _h('th', {
	    attrs: {
	      "scope": "row"
	    }
	  }, ["Votes"])
	}},function (){with(this) {
	  return _h('th', {
	    attrs: {
	      "scope": "row"
	    }
	  }, ["Rating"])
	}}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.8c37cb2152efb5719079.js